<template>
  <div id="browse-marketplace">
    <div>
      <v-container class="content-wrapper" fluid>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12"></v-col>
          <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
            <v-select
              v-model="selectedCatalogue"
              :items="catalogueOptions"
              outlined
              hide-details
              background-color="#fafbff"
              class="custom-select"
              @change="navigateToCatalogue"
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <router-view></router-view>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicCatalogueAndMarketplace',

  data() {
    return {
      selectedCatalogue: 'Browse the Catalogue of Services',
      catalogueOptions: [
        'Browse the Catalogue of Services',
        'Browse the Catalogue of Providers',
        'Browse the Catalogue of Equipment',
        'Browse the Catalogue of Patents',
        'Browse the Catalogue of Hosting Institutions',
      ],
    };
  },

  watch: {
    '$route.query.selectedCatalogue'(newValue) {
      if (newValue) {
        this.selectedCatalogue = newValue;
      }
    },
  },

  mounted() {
    if (this.$route.query.selectedCatalogue) {
      this.selectedCatalogue = this.$route.query.selectedCatalogue;
    }
  },

  methods: {
    navigateToCatalogue() {
      let routePath = '';

      switch (this.selectedCatalogue) {
        case 'Browse the Catalogue of Services':
          routePath = '/public-catalogue-marketplace/services';
          break;
        case 'Browse the Catalogue of Providers':
          routePath = '/public-catalogue-marketplace/providers';
          break;
        case 'Browse the Catalogue of Equipment':
          routePath = '/public-catalogue-marketplace/equipment';
          break;
        case 'Browse the Catalogue of Patents':
          routePath = '/public-catalogue-marketplace/patents';
          break;
        case 'Browse the Catalogue of Hosting Institutions':
          routePath = '/public-catalogue-marketplace/hosting-institutions';
          break;
        default:
          routePath = '/public-catalogue-marketplace';
      }

      this.$router.push({
        path: routePath,
        query: {
          selectedCatalogue: this.selectedCatalogue,
        },
      });
    },
  },
};
</script>

<style>
#browse-marketplace .v-toolbar {
  background: rgba(250, 250, 250, 1) !important;
  border-bottom: 2px solid #f4f2f9 !important;
}

#browse-marketplace .custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
